module.exports = __webpack_public_path__ + "static/img/contact_qrcode.6add0cd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/contact_qrcode.jpeg
// module id = B7gZ
// module chunks = 3